import { AxiosError, AxiosResponse } from "axios";
import { DataType, FieldType } from "@websential/cosmic-v20";
import { IGetListRequest, IResponse, IServerError } from "../models/common";
import {
  IPayrollSchedule,
  IPayrollScheduleListPayload,
  IPayrollScheduleResponse,
} from "../models/PayrollSchedule";

import { GridSize } from "@mui/material";
import http from "../common/http-commons";

// import { IFixedAndMetaField } from 'common/FlexFieldsUtils';

// import { IVendorListPayload, IVendorRequest, IVendorResponse } from 'models/vendor';
// import { CLIENT_SETUP_FORM, CLIENT_SETUP_FORM_FOR_ADMIN_USER } from 'screensLayoutData/client';

// import { IAPIKeysRequest, IAPIKeysResponse } from '../models';

// import { IPayrollScheduleListPayload, IPayrollScheduleRequest, IPayrollScheduleResponse } from '../models/departments';

// import { INITIAL_PAGE_SIZE } from 'common/constants';

export const PayrollScheduleService = {
  getPayrollSchedule: async (
    clientId: string,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<
    | IPayrollScheduleListPayload
    | IServerError
    | IResponse
    | IPayrollScheduleResponse[]
  > => {
    try {
      const response: AxiosResponse<IPayrollScheduleListPayload> =
        await http.get<IPayrollScheduleListPayload>(
          "/v1/departmentss/?client_id=" +
            clientId +
            "&order_by=" +
            data.order_by +
            "&order_direction=" +
            data.order_direction +
            "&page=" +
            data.page +
            "&size=" +
            data.size +
            "&search_query=" +
            data.search_query,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getById: async (
    clientId: string,
    id: string | undefined,
    selectedYear: number,
    navigateToLogout: (path: string) => void,
  ): Promise<IPayrollSchedule | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IPayrollSchedule> =
        await http.get<IPayrollSchedule>(
          `/v1/payroll-schedule/${id}/by-tax-year/?tax_year=${selectedYear}`,
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<IPayrollSchedule | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IPayrollSchedule> =
          await http.put<IPayrollSchedule>(
            `/v1/payroll-schedule/${requestPayload.id}/`,
            requestPayload,
          );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IPayrollSchedule> =
        await http.post<IPayrollSchedule>(
          `/v1/payroll-schedule/`,
          requestPayload,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delPayrollSchedule: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/payroll-schedule/${delPayload.payrollScheduleId}/`,
      );

      if (response.status === 200) {
        return "Payroll Schedule has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkPayrollSchedulees: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/departments/`, {
        data: requestPayload.departmentsIds,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getGetPayrollScheduleDDL: async (
    clientId: string,
  ): Promise<any | IServerError | IResponse | null> => {
    const response: AxiosResponse<any[]> = await http.get<any[]>(
      `/v1/departments/department-ddl?client_id=${clientId}`,
    );

    if (response.status === 200) {
      return response.data;
    }

    return {
      status: false,
      message: "Something went wrong please try again later.",
    };
  },
  archivePayrollSchedule: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/departments/${archivePayload.departmentsId}/`,
      );

      if (response.status === 201) {
        return "PayrollSchedule has been archived successfully";
      } else if (response.status === 200) {
        return "PayrollSchedule has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getYearsDDL: async (
    clientId: string,
    taxYear: number,
  ): Promise<any | IServerError | IResponse | null | any> => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/payroll-schedule/ddl-get-payroll-schedule-years-ddl/?client_id=${clientId}&tax_year=${taxYear}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getPayrollFrequenciesDDL: async (): Promise<
    any | IServerError | IResponse | null | any
  > => {
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/payroll-frequencies/payroll-frequencies-ddl`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getPayPeriodLabelsDDL: async (
    clientId: string,
    selectedPayPeriodId: string | null,
  ): Promise<any | IServerError | IResponse | null | any> => {
    if (!selectedPayPeriodId) return null;
    try {
      const response: AxiosResponse<any> = await http.get<any>(
        `/v1/payroll-schedule/ddl-pay-period-labels/?client_id=${clientId}&pay_period_id=${selectedPayPeriodId}`,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 404) {
        return [];
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 404) {
        return [];
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getPayrollSchedulePermissions: async (
    clientId: string,
    payrollScheduleId: string | undefined,
  ): Promise<IServerError | IResponse | any | null> => {
    if (!payrollScheduleId) return null;
    try {
      const response: AxiosResponse<any> =
        await http.get<any>(
          `/v1/payroll-schedule/permissions/for-shedule/for-employee/from-salary-profile/data/?client_id=${clientId}&payroll_shedule_id=${payrollScheduleId}`
        );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
        return {
          status: false,
          message: errorMessage,
        };
    }
  },
};
